import ChemistryProducersMap from './ChemistryProducersMap';

export default ChemistryProducersMap;
